import { apiClient } from "./apiClient";

/**
 * Resolve a media URL (e.g. avatar) against the regional API base URL.
 *
 * The API returns avatar paths like `/media/staff/4221219/abc.webp`.
 * Without this helper the browser resolves them against the page origin
 * (e.g. `admin.boona.app`), but we need them served from the regional
 * API shard (e.g. `api-by.boona.app`).
 *
 * - Already-absolute URLs (https://…) are returned as-is.
 * - Relative paths are prefixed with `apiClient.defaults.baseURL`.
 * - Falsy / placeholder values pass through unchanged.
 */
export function resolveMediaUrl(raw: string | undefined | null): string {
  if (!raw || raw === "/placeholder-user.jpg") return raw ?? "";

  // Already absolute → keep as-is
  if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;

  const base = apiClient.defaults.baseURL;
  if (!base) return raw; // baseURL not yet configured — nothing we can do

  // Avoid double slashes when concatenating
  const sep = base.endsWith("/") || raw.startsWith("/") ? "" : "/";
  return base + sep + raw;
}
